import React from "react";

function ActionButtons({ params, approveReco, onClickBack }) {
  return (
    <div className="mt-4 text-center">
      {params?.approve ? (
        <>
          <button
            type="button"
            className="btn fs-sm w-25"
            onClick={onClickBack}
            style={{ backgroundColor: "#d1d1d1" }}
          >
            Cancel
          </button>

          {
            //   params?.approve === "reconciliation" ? (
            //     <button
            //       // type="submit"
            //       onClick={approveReco}
            //       className="btn fs-sm text-white ms-3 w-25"
            //       style={{ backgroundColor: "#82c14a" }}
            //     >
            //       <i className="bi text-white bi-file-earmark-check me-2"></i>
            //       Approve
            //     </button>
            //   ) :
            <button
              type="submit"
              className="btn fs-sm text-white ms-3 w-25"
              style={{ backgroundColor: "#82c14a" }}
            >
              <i className="bi text-white bi-file-earmark-check me-2"></i>
              Approve
            </button>
          }
        </>
      ) : (
        <button
          type="button"
          className="btn fs-sm w-50 text-white"
          onClick={onClickBack}
          style={{ backgroundColor: "#82c14a" }}
        >
          Back
        </button>
      )}
    </div>
  );
}

export default ActionButtons;
